var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"overlay",style:({width: _vm.windowWidth+'px'}),on:{"mousedown":function (e) { return _vm.$emit('mousedown', e); }}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }